<template>
  <!-- 头部整体盒子 -->
  <div>
    <div id="header" class="container-fluid">
    <!-- 头部顶部 -->

      <!-- 电脑导航 -->
    <div class="header-nav container-fluid hidden-xs">
      <!-- 导航logo -->
      <div class="header-nav-logo">
        <img src="@/assets/img/logo.png" alt="">
      </div>
      <!-- 导航内容 -->
      <ul class="header-nav-wrapper">
        <li
          v-for="(item,index) in navList"
          :key="index"
          :class="index==navIndex?'active':''"
          @click="navClick(index,item.name)"
        >
          <router-link :to="item.path">
            {{item.name}}
            <span v-if="item.children.length>0||item.children4.length>0" class="glyphicon glyphicon-menu-down"></span>
            <i class="underline"></i>
          </router-link>
          <dl v-if="item.children.length>0">
            <dt v-if="item.children.length>0" >仪器</dt>
            <dt v-for="(i,n) in item.children" :key="n">
              <router-link :to="'/product/instrumentPage/'+i.id">{{i.name}}</router-link>
            </dt>
            <dt v-if="item.children3.length>0" >试剂</dt>
            <dt v-for="point in item.children3" :key="point.id+'a'">
              <router-link :to="'/product/reagentPage/'+point.id">{{point.name}}</router-link>
            </dt>
            <dt v-if="item.children2.length>0" >软件</dt>
            <dt v-for="node in item.children2" :key="node.id+'b'">
              <router-link :to="'/product/softwarePage/'+node.id">{{node.name}}</router-link>
            </dt>
          </dl>

          <dl v-if="item.children4.length>0">
            <dt v-for="solution in item.children4" :key="solution.id+'c'">
              <router-link :to="'/solutionDetail/'+solution.id">{{solution.solutionTitle}}</router-link>
            </dt>
          </dl>
          <dl v-if="item.children5">
            <dt v-for="joinUs in item.children5" >
              <router-link :to="joinUs.path">{{joinUs.name}}</router-link>
            </dt>
          </dl>
        </li>
      </ul>
    </div>


    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m visible-xs">
      <div class="header-nav-m-logo">
        <img class="center-block" src="../assets/img/logo.png" alt="logo">
      </div>
      <div>
        <a-button type="primary" @click="showDrawer">
          <a-icon type="menu-unfold" />
        </a-button>
        <a-drawer
          title="雨琪生物"
          placement="right"
          :closable="false"
          :visible="visible"
          :after-visible-change="afterVisibleChange"
          @close="onClose"
         >
          <div>
            <a-menu
              style="width: 256px"
              :open-keys.sync="openKeys"
              mode="inline"
              @click="handleClick"
            >
              <!--导航内容-->
              <a-sub-menu v-if="item.children.length>0"  :key="index" @titleClick="titleClick" v-for="(item,index) in navList">
                <span slot="title"><router-link :to="item.path"><span style="display:inline-block;height: 100%
;width: 85%">{{item.name}}</span></router-link></span>
                <a-menu-item-group v-if="item.children.length>0" title="仪器">
<!--                  <template slot="title"> <a-icon type="qq" /><span>Item 1</span> </template>-->
                  <a-menu-item v-for="(i,n) in item.children" :key="n+'b'">
                    <router-link :to="'/product/instrumentPage/'+i.id">{{i.name}}</router-link>
                  </a-menu-item>
                </a-menu-item-group>
                <a-menu-item-group v-if="item.children3.length>0" title="试剂">
                  <a-menu-item v-for="point in item.children3" :key="point.id+'c'">
                    <router-link :to="'/product/reagentPage/'+point.id">{{point.name}}</router-link>
                  </a-menu-item>
                </a-menu-item-group>
                <a-menu-item-group v-if="item.children2.length>0" title="软件">
                  <a-menu-item v-for="node in item.children2" :key="node.id+'a'">
                    <router-link :to="'/product/softwarePage/'+node.id">{{node.name}}</router-link>
                  </a-menu-item>
                </a-menu-item-group>
<!--                <a-menu-item style="padding-left: 32px;">-->
<!--                  <router-link :to="'/product/reagent'" v-if="item.children.length>0"><h5>试剂</h5></router-link>-->
<!--                </a-menu-item>-->
              </a-sub-menu>


              <a-sub-menu v-if="item.children4.length>0"  :key="index" @titleClick="titleClick" v-for="(item,index) in navList">
                <span slot="title"><router-link :to="item.path"><span style="display:inline-block;height: 100%
;width: 85%">{{item.name}}</span></router-link></span>
                  <a-menu-item v-for="(i,n) in item.children4" :key="n+'c'">
                    <router-link :to="'/solutionDetail/'+i.id">{{i.solutionTitle}}</router-link>
                  </a-menu-item>
              </a-sub-menu>

              <a-menu-item v-else >
                <router-link :to="item.path">{{item.name}}</router-link>
              </a-menu-item>
            </a-menu>
          </div>
        </a-drawer>
      </div>
    </div>
  </div>
</template>
<script>
import { getAction } from '../api/manage'


export default {
  name: "Header",
  data() {
    return {
      language: 'zh',
      current: ['mail'],
      openKeys: ['sub1'],
      visible: false,
      navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
      menuName: "首页",
      menuClass: "glyphicon glyphicon-menu-down",
      navList: [
        {
          name: "首页",
          path: "/",
          children: [],
          children2: [],
          children3: [],
          children4: []
        },
        {
          name: "产品",
          path: "",
          children: [],
          children2: [],
          children3: [],
          children4: []
        },
        {
          name: "解决方案",
          path: "",
          children: [],
          children2: [],
          children3: [],
          children4: []
        },
        {
          name: "关于我们",
          path: "/aboutUs",
          children: [],
          children2: [],
          children3: [],
          children4: []
        },
        {
          name: "加入我们",
          // path: "/contactus",
          path: "",
          children: [],
          children2: [],
          children3: [],
          children4: [],
          children5: [
            {
              name: "联系我们",
              path: "/contactus",
            },{
              name: "人才招聘",
              path: "/recruitment",
            },
          ],
        },
        // {
        //   name: "人才招聘",
        //   path: "/recruitment",
        //   children: [],
        //   children2: [],
        //   children3: [],
        //   children4: []
        // }
      ]
    };
  },
  /* watch: {
    openKeys(val) {
      console.log('openKeys', val);
    },
  }, */
  methods: {
    // 翻译
/*     languageAuto() {
      this.language === 'zh' ? (this.language = 'en') : (this.language = 'zh')
      localStorage.setItem('language', `{"language":"${this.language}"}`)
      if (this.language === 'zh') {
        console.log(this.$translate)
        this.$translate.changeLanguage('chinese_simplified')
      }
      if (this.language === 'en') {
        console.log(this.$translate)
        this.$translate.changeLanguage('english')
      }
      this.$translate.execute() //进行翻译
    }, */
    // 手机导航菜单
    handleClick(e) {
      console.log('click', e);
    },
    titleClick(e) {
      console.log('titleClick', e);
    },
    // 抽屉
    afterVisibleChange(val) {
      console.log('visible', val);
    },
    showDrawer() {
      this.visible = true;
    },
    onClose() {
      this.visible = false;
    },
    navClick(index, name) {
      this.navIndex = index;
      sessionStorage.setItem('navIndex',index)
      this.menuName = name;
    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    },
    // 加载仪器导航
    loadInstrumentNav() {
      // 查询条件
      let queryParam = {
        currentPage: 1,
        pageSize: -1,
        search: {
          isNav:'1',
          name: '',
          remark: ''
        }
      }
      getAction('/instrument/list', queryParam).then((res) => {
        this.navList[1].children=res.data.data.rows;
      })

    },
    // 加载软件导航
    loadSoftwareNav() {
      // 查询条件
      let queryParam = {
        currentPage: 1,
        pageSize: -1,
        search: {
          id:'',
        }
      }
      getAction('/software/list', queryParam).then((res) => {
        this.navList[1].children2=res.data.data.rows;
      })

    },
    // 加载软件导航
    loadReagentNav() {
      // 查询条件
      let queryParam = {
        currentPage: 1,
        pageSize: -1,
        search: {
          isNav:'1',
        }
      }
      getAction('/reagent/list', queryParam).then((res) => {
        this.navList[1].children3=res.data.data.rows;
      })
    },
    //加载解决方案导航
    loadSolutionNav() {
      // 查询条件
      let queryParam = {
        currentPage: 1,
        pageSize: -1,
        search: {}
      }
      getAction('/solution/list', queryParam).then((res) => {
        this.navList[2].children4=res.data.data.rows;
      })
    }
  },
  created () {
    this.loadInstrumentNav();
    this.loadSoftwareNav();
    this.loadReagentNav();
    this.loadSolutionNav();
  },
  mounted () {
  }
};
</script>
<style>
/* 顶部 */
#header {
  background: #fff;
  transition: all ease 0.6s;
  z-index: 999;
}
#header .header-top {
  height: 50px;
  color: #fff;
  font-size: 12px;
  line-height: 50px;
  background: #474747;
}
/* 顶部的图标 */
#header .header-top span {
  margin: 0 8px;
}
/* 导航栏 */
#header .header-nav {
  height: 140px;
}
/* 导航栏logo */
#header .header-nav .header-nav-logo {
  width: 300px;
  height: 100%;
  float: left;
  position: relative;
}
/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {
  width: 200px;
  height: auto;
  position: absolute;
  top: 0;
  left: 50px;
  right: 0;
  bottom: 0;
  margin: auto;
}
/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 50px;
}
#header .header-nav .header-nav-wrapper {
  line-height: 140px;
  float: right;
  margin: 0;
  max-width: 800px;
}
/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper > li {
  float: left;
  margin: 0 15px;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper > li > a {
  font-weight: 500;
  color: #000000;
  font-size: 22px;
  padding: 15px 0;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper > li > a > i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #e6380d;
}
/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper > li > a > span {
  font-size: 15px;
  transition: transform ease 0.5s;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover {
  color: #e6380d;
  text-decoration: none;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover span {
  transform: rotate(180deg);
}
/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper > li.active > a {
  color: #e6380d;
  text-decoration: none;
  border-bottom: 2px solid #e6380d;
}
/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper > li > dl {
  border-radius: 2px;
  display: none;
  position: absolute;
  width: 230px;
  top: 80%;
  left: 0;
  z-index: 999999;
  box-shadow: 0 0 1px 1px #f3f3f3;
  background: #fff;
  padding:15px 0 15px 0;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper > li > dl > dt {
  width: 100%;
  padding: 10px;
}
#header .header-nav .header-nav-wrapper > li > dl > dt > a {
  width: 100%;
  height:100%;
  text-decoration: none;
  display: block;
  font-weight: lighter;
  color: #777777;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper > li > dl > dt > a:hover {
  text-decoration: none;
}
#header .disabled {
  background: white;
}
/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper > li:hover dl {
  display: block;
}
#header .header-nav .header-nav-wrapper > li > dl > dt:hover {
  cursor: pointer;
  background: #e6380d;
  color: white;
}
#header .header-nav .header-nav-wrapper > li > dl > dt:hover a{
  color: white;
}
#header .header-nav .header-nav-wrapper > li > dl > dt h5{
  margin: 0;
  padding: 0;
  font-weight: bold;
  color: #000000;
}
#header .header-nav .header-nav-wrapper > li > dl > dt:hover h5{
  color: #FFFFFF;
}
@media screen and (max-width: 997px) {
  #header .header-nav-m {
    position: relative;
  }
  /* 导航栏logo容器 */
   .header-nav-m .header-nav-m-logo {
    height: 80px;
    position: relative;
    margin: 0;
    padding: 0;
  }
  /* 导航栏logo图片 */
   .header-nav-m .header-nav-m-logo img {
    width: auto;
    height: 60px;
     margin-left: 30px;
     margin-top: 15px;

  }
  /* 导航栏  菜单容器 */
  .header-nav-m button{
    padding: 0;
    width: 50px;
    height: 45px;
    font-size: 27px;
    color: #373a47;
    border: transparent;
    background-color: transparent;
    position: absolute;
    right: 22px;
    top: 18px;
  }
  .ant-drawer-body{
    padding: 0;
  }
  a{
    color: #000c17;
    text-decoration: none;
  }
  a:hover{
    text-decoration: none;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue